import { v4 } from 'uuid';

export default function generateCorrelationId() {
	return v4();
}
